import { css } from '@linaria/atomic';

export const endAdornmentRow = css`
  display: flex;
  align-items: center;
`;
